<template>
  <b-container>
    <ProfileHero :user="user" v-if="user" />
    <FanProfileTabs :user="user" v-if="user" />

    <div class="content">
      <b-row v-if="user">
        <b-col v-html="formatText(user.bio)" v-if="user.bio" />
        <b-col v-else class="text-center empty">
          This user hasn't added their personal information yet
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';

  .content {
    padding-left: 6px;
    padding-right: 6px;
  }
  .empty {
    text-align: center;
    margin-top: 1em;
    color: $steel;
  }
</style>

<script>
import { formatText } from '@/utils/textformat'

import FanEditProfileTabs from '@/components/widgets/FanEditProfileTabs'
import FanProfileTabs from '@/components/widgets/FanProfileTabs'
import ProfileHero from '@/components/widgets/ProfileHero'

export default {
  name: 'Home',
  components: {
    FanEditProfileTabs,
    FanProfileTabs,
    ProfileHero
  },
  data () {
    return {
      user: null
    }
  },
  computed: {
    publicProfilePreview () {
      return this.$route.meta.profilePreview || false
    }
  },
  created () {
    this.initPage()
  },
  watch: {
    '$route': 'initPage'
  },
  methods: {
    async initPage () {
      if (this.$route.params.handle) return this.resolveHandle(this.$route.params.handle)

      if (this.publicProfilePreview) {
        this.user = this.$store.getters['profile/currentUser']
      } else {
        try {
          this.user = await this.$store.dispatch('profile/getProfile', { id: this.$route.params.id })
        } catch (e) {
          this.$store.dispatch('flash/showMessage', {message: 'Fan account no longer exists', type: 'error'})
          this.$router.replace({'name': 'discover'})
        }
      }
    },
    async resolveHandle (handle) {
      let users = await this.$store.dispatch('profile/findProfile', { handle })
      if (!users.count) {
        this.$store.dispatch('flash/showMessage', {message: 'No such user', type: 'error'})
        this.$router.replace({'name': 'discover'})
        return
      }
      let user = users.results[0]
      if (user.artist && user.artist.handle.toLowerCase() === handle.toLowerCase()) {
        this.$router.replace({name: 'artist-about', params: {artistId: user.artist.id}})
      } else {
        this.$router.replace({name: 'fan-profile', params: {id: user.id}})
      }
    },
    formatText
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/fan/Profile.vue